import IntroScreen from './IntroScreen';
import withResponsiveUtils from '../../utils/ResponsiveUtils';

export default withResponsiveUtils(IntroScreen);
